/**
 * BioSectionCollapse.js - Adds collapsible functionality to bio sections
 * 
 * This module handles the collapsible functionality for bio section panels.
 * It allows users to expand and collapse individual bio sections.
 */

export class BioSectionCollapse {
    constructor() {
        // Initialize the collapsible sections
        this.initCollapseButtons();
    }

    /**
     * Initialize the collapse buttons for bio sections
     */
    initCollapseButtons() {
        // Find all collapse buttons
        const collapseButtons = document.querySelectorAll('.bio-collapse-btn');
        
        // Add click event listeners to each button
        collapseButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                
                // Find the parent bio section
                const bioSection = button.closest('.bio-section');
                
                // Toggle the collapsed class
                bioSection.classList.toggle('collapsed');
                
                // Stop event propagation to prevent other handlers
                e.stopPropagation();
            });
        });

        // Add click event listener to section titles to also toggle collapse
        const sectionTitles = document.querySelectorAll('.bio-section-title');
        sectionTitles.forEach(title => {
            title.addEventListener('click', (e) => {
                // Only toggle if the click was directly on the title
                if (e.target === title) {
                    const bioSection = title.closest('.bio-section');
                    const collapseButton = bioSection.querySelector('.bio-collapse-btn');
                    
                    // Trigger a click on the collapse button
                    if (collapseButton) {
                        collapseButton.click();
                    }
                }
            });
        });
    }

    /**
     * Collapse all sections except one (useful when opening a specific section)
     * @param {HTMLElement} exceptSection - The section to keep expanded
     */
    collapseAllExcept(exceptSection) {
        const bioSections = document.querySelectorAll('.bio-section');
        bioSections.forEach(section => {
            if (section !== exceptSection) {
                section.classList.add('collapsed');
            }
        });
    }

    /**
     * Expand all sections
     */
    expandAll() {
        const bioSections = document.querySelectorAll('.bio-section');
        bioSections.forEach(section => {
            section.classList.remove('collapsed');
        });
    }

    /**
     * Collapse all sections
     */
    collapseAll() {
        const bioSections = document.querySelectorAll('.bio-section');
        bioSections.forEach(section => {
            section.classList.add('collapsed');
        });
    }
}